import { Button, Stack, Typography } from "@mui/material";
import { FormikErrorNotification, FormikTextField } from "@shared";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { useTranslation } from "@/translations";

import { AmsMappingTable } from "./components/ams-mapping-table/AmsMappingTable";
import { useAmsParametersSettings } from "./hooks/useAmsParametersSettings";

function AmsParametersSettingsInner() {
  const { t } = useTranslation();
  const { formik, isSaving, handleAddMapping, handleDeleteMapping } = useAmsParametersSettings();

  return (
    <Stack component="form" onSubmit={formik.handleSubmit} flex="1 1 100%" overflow="hidden" gap={3} bgcolor="white">
      <FormikErrorNotification formik={formik} />

      <Stack gap={1}>
        <Typography variant="body2" color="text.secondary">
          {t("settings.amsParameters.description")}
        </Typography>
      </Stack>

      <Stack flex={1} gap={3} sx={{ overflowY: "auto", pr: 1 }}>
        <Stack maxWidth={320} pt={1}>
          <FormikTextField
            formik={formik}
            fieldName="sid"
            label={t("settings.amsParameters.sid")}
            required
            slotProps={{ input: { inputProps: { inputMode: "numeric" } } }}
          />
        </Stack>

        <Stack gap={1}>
          <Typography variant="subtitle1" fontWeight={600}>
            {t("settings.amsParameters.mappingSection")}
          </Typography>
          <AmsMappingTable formik={formik} onAdd={handleAddMapping} onDelete={handleDeleteMapping} />
        </Stack>
      </Stack>

      <Stack direction="row" justifyContent="space-between" p={0.5} pb={2}>
        <Button variant="outlined" onClick={formik.handleReset} disabled={isSaving || !formik.dirty}>
          {t("common.resetChanges")}
        </Button>
        <Button variant="contained" type="submit" disabled={isSaving || !formik.dirty}>
          {t("common.save")}
        </Button>
      </Stack>
    </Stack>
  );
}

export const AmsParametersSettings = withAuthorization(AmsParametersSettingsInner, UserPermission.Supervisor);
